@if (latestSlicCode) {
  <div class="latest-slic-msg">
    {{ CONSTANTS.LAST_UPDATED_RECORD }} "{{ latestSlicCode }}"
    {{ CONSTANTS.LAST_UPDATED_SWITCH_NOTE }}
  </div>
}
<ion-button class="download-btn" (click)="exportToPdf()">
  <img [src]="IMAGES.EXCEL_WHITE" class="icon" alt="download" />
  <span class="text">{{ CONSTANTS.DOWNLOAD }}</span>
</ion-button>
<div class="package-inquiry-container" id="contentToPrint">
  @if (detailsData && detailsData.originDetails.length > 0) {
    <ion-grid>
      <ion-row>
        <ion-col size="7">
          <ion-row class="top-left-container">
            <!-- Top Section -->
            <app-details-card
              class="details"
              [size]="3"
              [data]="topData"
            ></app-details-card>
            <!----------------->
          </ion-row>
          <ion-row>
            <app-travel-section
              [origAddress]="origAddress"
              [destAddress]="destAddress"
            ></app-travel-section>
          </ion-row>
          <!-- Origin/Dest Cards Section -->
          <ion-row class="origin-container">
            <ion-col size="6">
              <!-- Origin Details-->
              <app-details-card [size]="6" [data]="origData"></app-details-card>
              <!----------------->
            </ion-col>
            <ion-col size="6">
              <!-- Dest Details-->
              <app-details-card [size]="6" [data]="destData">
                <!-- Address awkward last row for this case-->
                <ion-col [size]="12" class="container">
                  <ion-label class="title"
                    >{{ CONSTANTS.LOCATION_ROLE }}:</ion-label
                  >
                  <ion-text class="desc">
                    {{ detailsData.destDetails[0]?.locationRole ?? "" }}
                  </ion-text>
                </ion-col>
                <!----------------->
              </app-details-card>
              <!----------------->
            </ion-col>
          </ion-row>
          <!----------------->
        </ion-col>
        <ion-col size="5" class="accessorials-container">
          <!-- Accessorials -->
          <app-accesorial-card
            [title]="CONSTANTS.ACCESSORIALS"
            [size]="4"
            [data]="accessorialsData"
          >
          </app-accesorial-card>
          <!----------------->
          <!-- Hazmat Accessorials -->
          <app-accesorial-card
            [title]="CONSTANTS.HAZMAT"
            [size]="4"
            [data]="hazmatData"
          >
          </app-accesorial-card>
          <!----------------->
          <!-- Time Section-->
          <app-accesorial-card
            [title]="null"
            [hasSeperator]="false"
            [size]="4"
            [data]="timeData"
          ></app-accesorial-card>
          <!----------------->
        </ion-col>
      </ion-row>
    </ion-grid>
  } @else {
    <app-no-result [message]="NO_RESULTS"></app-no-result>
  }
</div>
